<!--
 * @Author: Lisisi
 * @Date: 2023-07-17 17:52:13
 * @LastEditTime: 2023-09-19 11:05:52
 * @LastEditors: your name
 * @Description:
-->
<template>
  <div class="charts barStackCharts" style="width: 100%">
    <div
      style="background: #d1534b4a;
      border-radius: 9px;
      height: 16px;
      color: #D1534B;
      line-height: 25px;
      font-size: 10px;
      width: auto;
      text-align: center;
      margin-top: 11px;
      margin-bottom: 10px;
      margin-left: 14px;
      font-weight: bold;
      display: inline-block;
      line-height: 16px;
      padding: 0 15px;"
    >
      <p>{{ chartTitle }}</p>
    </div>
    <div style="height:200px" ref="barStackCharts"></div>
    <div
      class="zdyTable"
      v-if="chartData.totalDuibi && chartData.totalDuibi.tableData"
      style="overflow-x: auto;width: calc(100% - 28px); font-size: 9px; font-family: MicrosoftYaHei;color: #3A3A3B;margin: 7px 14px 7px 14px; background: #FAFAFF; box-shadow: inset 0px 0px 4px 0px #D3D3E3; border-radius: 4px;"
    >
      <!-- <div
        v-for="(item, index) in chartData.totalDuibi"
        :key="index"
        style="white-space: nowrap;border-bottom: 1px solid #e1e1ea80; display: table;"
      >
        <span
          style=" width: 48px;vertical-align: middle;padding: 4px 7px;word-break: break-word; display: inline-flex;align-items: center;"
          v-for="(child, indexC) in item"
          :key="index + indexC"
        >
          <span
            v-if="indexC === 0"
            style="white-space: normal;font-size: 7px; font-family: MicrosoftYaHei; color: rgba(58,58,59,0.51);line-height: 12px;"
            >{{ child }}</span
          >
          <span v-if="indexC !== 0">{{ child }}</span>
        </span>
      </div> -->
      <el-table
        :data="chartData.totalDuibi.tableData"
        border
        stripe
        ref="tableList"
        style="width: 100%; background: #FAFAFF;box-shadow: inset 0px 0px 4px 0px #D3D3E3;border-radius: 4px;"
        class="zdytablewrap"
        :show-header="true"
        :row-style="{ height: '30px', background: '#FaFaFF!important' }"
        :cell-style="{
          padding: '0',
          lineHeight: '12px',
          borderColor: '#e1e1ea80'
        }"
      >
        >
        <el-table-column
          :fixed="item.fixed"
          v-for="(item, index) in chartData.totalDuibi.tableColumn"
          :key="index"
          :prop="item.prop"
          :min-width="item.width"
          :label="item.label"
          :align="item.align ? item.align : 'center'"
        >
          <template slot="header">
            <span>{{ item.prop == "category" ? "" : item.label }}</span>
          </template>
          <template slot-scope="scope">
            <template>
              <span :class="item.prop === 'category' ? 'catogory' : ''">
                {{ scope.row[item.prop] }}
              </span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Tools from "@/utils/tools";
export default {
  name: "barStackCharts",
  data() {
    return {
      myChart: null
    };
  },
  created() {},
  props: {
    chartData: Object,
    chartTitle: String
  },
  watch: {
    chartData: {
      handler(val) {
        console.log(val, "46----");
        this.$nextTick(() => {
          //使用this.$nexTick方法进行渲染
          console.log(val, "45----");
          if (val) {
            this.myChart && this.myChart.clear();
            this.drawChart();
          } else {
            this.myChart != null && this.myChart.clear();
          }
        });
        // console.log(val,"888");
      },
      deep: true, // 深度监听
      immediate: true // 初次监听即执行
    }
  },
  mounted() {
    this.gundongControl();
    window.addEventListener("resize", () => {
      if (this.myChart) {
        this.myChart.clear();
        this.myChart.setOption(this.initChart());
        this.myChart.resize();
      }
    });
  },
  methods: {
    gundongControl() {
      this.$nextTick(() => {
        //先获取到 该表格的宽度
        var widthKK = this.$refs.tableList.bodyWidth;
        //解决 scrollLeft  值赋不上值的问题
        setTimeout(() => {
          this.$refs.tableList.bodyWrapper.scrollLeft = Number(
            widthKK.replace("px", "")
          );
        }, 1000); //必须是1000以上 才能生效
      });
    },
    rowStyle({ row, rowIndwx }) {
      let styleJson = {};
      styleJson.background = "#F6F6FF";
      // if (row.SubBU == this.showTatol||row.label == this.showTatol ||row.rc == this.showTatol ||row.rsd == '邬俊亮' ) {
      //     styleJson.color = "rgb(130, 22, 82)";
      // }

      return styleJson; // 返回对象
    },
    drawChart() {
      if (!this.$refs.barStackCharts) {
        return;
      }
      this.myChart = null;
      this.myChart = this.$echarts.init(this.$refs.barStackCharts);
      this.myChart.setOption(this.initChart());
    },
    initChart() {
      return Tools.getEchartsOptionCommon(this.chartData);
    }
  }
};
</script>
<style>
.zdytablewrap .el-table__fixed-header-wrapper tr .cell,
.zdytablewrap .el-table__header-wrapper tr .cell,
.zdytablewrap .el-table__body-wrapper tbody tr .cell,
.zdytablewrap .el-table__fixed-body-wrapper tbody tr .cell {
  width: 100%;
  line-height: 14px;
  justify-content: center;
  align-items: center;
  padding: 7px 8px;
  font-size: 9px;
  font-family: MicrosoftYaHei;
  color: #3a3a3b;
  word-break: break-word;
  transform: scale(0.82);
  font-weight: normal;
}
.zdytablewrap .el-table__header-wrapper tr th.el-table__cell,
.zdytablewrap .el-table__fixed-header-wrapper tr th.el-table__cell {
  border-bottom: 1px solid #e1e1ea80;
}
.zdytablewrap .el-table__header-wrapper tr th.el-table__cell,
.zdytablewrap .el-table__fixed-header-wrapper tr th.el-table__cell,
.zdytablewrap .el-table__body-wrapper tbody tr td,
.zdytablewrap .el-table__fixed-body-wrapper tbody tr td {
  background: #fafaff !important;
  border-right: 0;
}
.zdytablewrap .el-table__body-wrapper tbody tr .cell .catogory,
.zdytablewrap .el-table__fixed-body-wrapper tbody tr .cell .catogory {
  font-size: 6px;
  line-height: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(58, 58, 59, 0.51);
}
</style>



// WEBPACK FOOTER //
// src/components/ButSecoend/Ecview/SumTableDrawChart.vue